import type { SvgComponent } from '@/types/SvgComponent';

export const SetAsInputIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <g clipPath="url(#clip0_13_3154)">
        <path
          d="M12.5 11.5L17.5 6.5"
          stroke="currentColor"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 10.5L17.4994 6.50062L13.5 6.5"
          stroke="currentColor"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.5 12.5V17C15.5 17.1326 15.4473 17.2598 15.3536 17.3536C15.2598 17.4473 15.1326 17.5 15 17.5H7C6.86739 17.5 6.74021 17.4473 6.64645 17.3536C6.55268 17.2598 6.5 17.1326 6.5 17V9C6.5 8.86739 6.55268 8.74021 6.64645 8.64645C6.74021 8.55268 6.86739 8.5 7 8.5H11.5"
          stroke="currentColor"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_13_3154">
          <rect width="16" height="16" fill="currentColor" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  );
};
